export default "__VITE_ASSET__BAQb1TeM__"